import {
  GET_SETTINGS,
  CREATE_SETTINGS,
  UPDATE_SETTING,
  SETTING_ERROR,
} from "../actions/types";

const initialState = {
  settings: {},
  setting: {},
  loading: true,
  error: {},
};

export default function (state = initialState, action) {
  const { type, payload } = action;
  switch (type) {
    case GET_SETTINGS:
    case CREATE_SETTINGS:
      return {
        ...state,
        settings: payload,
        loading: false,
      };
    case UPDATE_SETTING:
      return {
        ...state,
        settings: payload,
        loading: false,
      };
    case SETTING_ERROR:
      return {
        ...state,
        error: payload,
        loading: false,
      };
    default:
      return state;
  }
}
